export const Roles = {
    ADMIN: 'admin',
    USER: 'user',
    READONLY: 'readonly',
    USERPRO: 'userPro',
    WAREHOUSEADMIN: 'warehouseAdmin',
    WAREHOUSEUSER: 'warehouseUser'
}